import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { useSignUp } from "@clerk/clerk-react";
import { useLocation, useNavigate } from "react-router-dom";
import OtpInput from "react-otp-input";

export default function VerifyAccountPassword() {
  const { signUp, setActive, isLoaded } = useSignUp();
  const navigate = useNavigate();
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const username = query.get("username");
  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState("");

  const handleVerify = async () => {
    if (!isLoaded) return;

    if (otp.length < 6) {
      setOtpError("Please enter complete OTP");
      return;
    }

    try {
      const completeSignUp =
        await signUp.attemptEmailAddressVerification({
          code: otp,
        });

      if (completeSignUp.status === "complete") {
        await setActive({
          session: completeSignUp.createdSessionId,
        });
        window.location.href = username
          ? `/user/creator-list?username=${username}`
          : "/user/creator-list";
      }
    } catch (err) {
      setOtpError(
        err.errors?.[0]?.message || "Invalid verification code"
      );
    }
  };

  return (
    <>
      <Helmet>
        <title>Verify OTP</title>
      </Helmet>

      <section className="authBody accountVerification flex items-center justify-center min-h-screen">
        <div className="bg-black p-8 rounded-2xl shadow-lg w-full max-w-md text-center">
          <h2 className="text-2xl font-bold mb-2">
            Verify Your Email
          </h2>
          <p className="text-gray-500 mb-6">
            Enter the 6-digit code sent to your email
          </p>

          <OtpInput
            value={otp}
            onChange={(value) => {
              setOtp(value);
              setOtpError("");
            }}
            numInputs={6}
            isInputNum
            shouldAutoFocus
            containerStyle={{
              justifyContent: "center",
              gap: "10px",
              marginBottom: "20px",
            }}
            inputStyle={{
              width: "45px",
              height: "55px",
              fontSize: "20px",
              borderRadius: "8px",
              backgroundColor: "#262d31",
              color: "#fff",
              border: otpError
                ? "1px solid red"
                : "1px solid #d1d5db",
            }}
            renderInput={(props) => (
              <input {...props} type="tel" />
            )}
          />

          {otpError && (
            <p className="text-red-500 text-sm mb-4">
              {otpError}
            </p>
          )}

          <button
            onClick={handleVerify}
            className="w-full bg-primary text-white py-3 rounded-full font-semibold hover:opacity-90 transition"
          >
            Verify & Start Chat
          </button>
        </div>
      </section>
    </>
  );
}